import gql from 'graphql-tag';

export const GET_OPERATIONAL_NOTES = gql`
  query OperationalNotes($filter: GetLookupWithFilterInput) {
    operationalNotes(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      operationalNotes {
        data {
          companyId
          srcTable
          srcColumn
          text
          hasRelation
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
    }
  }
`;

export const OPERATIONAL_NOTES_MUTATION_CREATE = gql`
  mutation CreateOperationalNote($input: CreateLookupInputSimple!) {
    createOperationalNote(input: $input) {
      isSuccessful
      message
      operationalNote {
        companyId
        srcTable
        srcColumn
        text
        hasRelation
      }
    }
  }
`;

export const OPERATIONAL_NOTES_MUTATION_UPDATE = gql`
  mutation UpdateOperationalNote($input: UpdateLookupInputSimple!) {
    updateOperationalNote(input: $input) {
      isSuccessful
      message
      operationalNote {
        companyId
        srcTable
        srcColumn
        text
        hasRelation
      }
    }
  }
`;

export const OPERATIONAL_NOTES_MUTATION_DELETE = gql`
  mutation DeleteOperationalNote($input: DeleteLookupInputSimple!) {
    deleteOperationalNote(input: $input) {
      isSuccessful
      message
      operationalNote {
        companyId
        srcTable
        srcColumn
        text
        hasRelation
      }
    }
  }
`;